'use strict';

exports.__esModule = true;
exports.ALERT_TONES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AlertStyled = require('./AlertStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React-Wrapper-Pflichtmuster (wie Card.jsx): reicht `className` durch, damit
// Konsumenten via styled(Alert) ihr Layout ergaenzen koennen. Kapselt die
// Tone-Banner-Struktur (Icon + Content) zentral. Die drei Alt-Banner Error/Info/
// Success rendern jetzt nur noch <Alert tone="..."> mit ihren Defaults.
//
// Content-Modelle (verhaltens-erhaltend gegenueber den Alt-Bannern):
//  - `children` (Info/Success) ODER
//  - `message`/`details` (Error: message-Node + optionaler details-Node).
// Liegt `children` vor, gewinnt es; sonst werden message+details gerendert.
var Alert = function Alert(_ref) {
  var className = _ref.className,
      tone = _ref.tone,
      icon = _ref.icon,
      fullWidth = _ref.fullWidth,
      children = _ref.children,
      message = _ref.message,
      details = _ref.details,
      rest = _objectWithoutProperties(_ref, ['className', 'tone', 'icon', 'fullWidth', 'children', 'message', 'details']);

  return _react2.default.createElement(
    _AlertStyled.AlertBase,
    _extends({ className: className, tone: tone, fullWidth: fullWidth }, rest),
    icon && _react2.default.createElement(_AlertStyled.AlertIcon, { tone: tone, icon: icon }),
    _react2.default.createElement(
      _AlertStyled.AlertContent,
      { tone: tone },
      children != null ? children : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        message,
        details
      )
    )
  );
};

Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  tone: _propTypes2.default.oneOf(Object.values(_AlertStyled.ALERT_TONES)),
  // FontAwesome-Icon-Definition (faExclamationTriangle etc.); null = kein Icon.
  icon: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  fullWidth: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  message: _propTypes2.default.node,
  details: _propTypes2.default.node
} : {};

Alert.defaultProps = {
  className: undefined,
  tone: _AlertStyled.ALERT_TONES.ERROR,
  icon: null,
  fullWidth: false,
  children: null,
  message: null,
  details: null
};

exports.ALERT_TONES = _AlertStyled.ALERT_TONES;
exports.default = Alert;